document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-menu-drawer]');
  const open = document.querySelector('[data-menu-open]');
  const close = document.querySelector('[data-menu-close]');
  const setDrawer = (state) => {
    if (!drawer) return;
    drawer.classList.toggle('is-open', state);
    drawer.setAttribute('aria-hidden', String(!state));
    document.body.style.overflow = state ? 'hidden' : '';
  };
  open?.addEventListener('click', () => setDrawer(true));
  close?.addEventListener('click', () => setDrawer(false));
  drawer?.addEventListener('click', e => { if (e.target === drawer) setDrawer(false); });

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {threshold:.08});
  document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

  document.querySelectorAll('.thumb').forEach(btn => {
    btn.addEventListener('click', () => {
      const main = document.querySelector('[data-main-image]');
      if (main && btn.dataset.image) main.src = btn.dataset.image;
      document.querySelectorAll('.thumb').forEach(t => t.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  });

  const select = document.querySelector('[data-variant-select]');
  const radios = [...document.querySelectorAll('.variant-pills input[type="radio"]')];
  function syncVariant(){
    if(!select || radios.length === 0) return;
    const chosen = [];
    document.querySelectorAll('.variant-group').forEach(group => {
      const checked = group.querySelector('input:checked');
      if(checked) chosen.push(checked.value);
    });
    [...select.options].forEach(opt => {
      const parts = opt.textContent.trim().split(' / ');
      if(parts.length === chosen.length && parts.every((p,i)=>p===chosen[i])) {
        select.value = opt.value;
        const price = document.querySelector('#ProductPrice');
        const compare = document.querySelector('#ComparePrice');
        const atc = document.querySelector('[data-product-atc]');
        const stickyPrice = document.querySelector('[data-sticky-price]');
        const available = opt.dataset.available === 'true';
        if(price && opt.dataset.price) price.textContent = opt.dataset.price;
        if(compare) compare.textContent = opt.dataset.compare || '';
        if(stickyPrice && opt.dataset.price) stickyPrice.textContent = opt.dataset.price;
        if(atc) {
          atc.disabled = !available;
          atc.textContent = available ? `Aggiungi al carrello · ${opt.dataset.price}` : 'Esaurito';
        }
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
  radios.forEach(r => r.addEventListener('change', syncVariant));

  const qty = document.querySelector('#Quantity');
  document.querySelector('[data-qty-minus]')?.addEventListener('click',()=>{ if(qty) qty.value=Math.max(1,Number(qty.value||1)-1); });
  document.querySelector('[data-qty-plus]')?.addEventListener('click',()=>{ if(qty) qty.value=Number(qty.value||1)+1; });

  document.querySelector('[data-scroll-atc]')?.addEventListener('click', () => {
    document.querySelector('.product-form')?.scrollIntoView({behavior:'smooth',block:'center'});
  });

  // PawClean: jump from the purchase area to the existing reviews widget.
  document.querySelector('[data-review-jump]')?.addEventListener('click', (event) => {
    const selectors = [
      '#recensioni-pawclean',
      '.verified-reviews-zone',
      '#judgeme_product_reviews',
      '.jdgm-rev-widg',
      '.loox-reviews-default',
      '.loox-reviews',
      '#shopify-product-reviews',
      '.spr-container',
      '[data-reviews-widget]',
      '[data-review-widget]'
    ];
    const target = selectors.map(selector => document.querySelector(selector)).find(Boolean);
    if (target) {
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});